<template>
    <main class="main" id="main">
        <navigate></navigate>
        <div class="lk-popup order-cancel" v-if="cancelOrder" style="transform: translateY(-50%);position: fixed;left: 0;right: 0;top: 50%;z-index: 999;margin:auto">
            <div class="title">
                <h1 style="display: inline-block;">Отклонить заказ</h1>
                <button class="cross" @click="cancelOrder = null" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div>
                    <div class="comment_box">
                        <span>Комментарий</span>
                        <textarea class="textarea" placeholder="Введите текст" v-model="textCancel"></textarea>
                    </div>
                    <button class="menu_item_btn"  @click="saveCancel" >СОХРАНИТЬ</button>
                </div>
            </div>
        </div>
        <div class="lk-popup info" style="position: fixed;left: 0;right: 0;top: 7%;z-index: 999;" v-if="currentOrderId !== null">
            <div class="title">
                <h1>Информация о заказе</h1>
                <button class="print_btn"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/print.svg" alt=""></button>
                <button class="cross" @click="currentOrderId = null" style="background: none;border: 0;"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" alt=""></button>
            </div>
            <div class="content_box">
                <div class="main_info">
                    <div class="info_item" v-if="currentOrder.name && currentOrder.name !== 'null'">
                        <span class="item_key">Имя:</span>
                        <span class="item_value">{{currentOrder.name}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.email && currentOrder.email !== 'null'">
                        <span class="item_key">E-mail:</span>
                        <span class="item_value">{{currentOrder.email}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.phone && currentOrder.phone !== 'null'">
                        <span class="item_key">Тел. номер:</span>
                        <span class="item_value">{{currentOrder.phone}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.city && currentOrder.city !== 'null'">
                        <span class="item_key">Город:</span>
                        <span class="item_value">{{currentOrder.city}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.street && currentOrder.street !== 'null'">
                        <span class="item_key">Улица:</span>
                        <span class="item_value">{{currentOrder.street}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.house && currentOrder.house !== 'null'">
                        <span class="item_key">Дом:</span>
                        <span class="item_value">{{currentOrder.house}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.floor && currentOrder.floor !== 'null'">
                        <span class="item_key">Этаж:</span>
                        <span class="item_value">{{currentOrder.floor}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.room && currentOrder.room !== 'null'">
                        <span class="item_key">Квартира:</span>
                        <span class="item_value">{{currentOrder.room}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.pay && currentOrder.pay !== 'null'">
                        <span class="item_key">Тип оплаты:</span>
                        <span class="item_value">{{currentOrder.pay}}</span>
                    </div>
                    <div class="info_item" v-if="currentOrder.when && currentOrder.when !== 'null'">
                        <span class="item_key">Срок доставки:</span>
                        <span class="item_value">{{currentOrder.when}}</span>
                    </div>
                </div>
                <div class="restaurant_box">
                    <div class="order_box" style="max-height: 30vh;overflow-y: scroll;">
                        <div class="order_item" v-for="(product, prodIndex) in currentOrder.products" :key="prodIndex">
                            <div class="primary_info">
                                <div class="description">
                                    <span>{{product.category}}</span>
                                    <h3 style="width: 270px;">{{product.name}}</h3>
                                    <p><span>{{product.price}} руб</span>/ {{product.weight}}</p>
                                </div>
                                <div class="counter">
                                    <span class="minus">-</span>
                                    <input type="text" :value="product.quantity"/>
                                    <span class="plus">+</span>
                                    <span class="cancel">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/cancel.svg" alt="">
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order_box">
                        <div class="totall">
                            <!-- <div class="sale">
                                <span>Скидка:</span>
                                <span>1200 руб</span>
                            </div> -->
                            <div class="price">
                                <span>Итого:</span>
                                <span>{{currentOrder.amount}} руб</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add_item">
                    <h2>Добавить товар</h2>
                    <select class="select_item">
                        <option value="">Начните вводить название...</option>
                        <option value="">2</option>
                        <option value="">3</option>
                    </select>
                    <div class="comment_box">
                        <h2>Комментарий</h2>
                        <form class="comment_form">
                            <textarea class="textarea" placeholder="Введите текст..."></textarea>
                            <button class="comment_submit" type="submit">ОК</button>
                        </form>
                        <p v-html="currentOrder.comments"></p>
                    </div>
                </div>
            </div>
        </div>
        <section class="section s-lk">
            <div class="container">
                <div class="monitor_box">
                    <table class="table monitor">
                        <thead>
                        <tr class="row">
                            <th>№</th>
                            <th>Поступил</th>
                            <th style="width: 30px;" v-if="user.access === 'admin'">Сайт</th>
                            <th v-if="user.access === 'admin'">Город</th>
                            <th v-if="user.access === 'admin'">Ресторан</th>
                            <th>Статус заказа</th>
                            <th>Подробнее</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="row" v-for="(order, index) in orders" :key="index">
                            <td class="td">{{order.id}}</td>
                            <td class="td">{{order.date}}</td>
                            <td class="td" v-if="user.access === 'admin'">{{order.locale}}</td>
                            <td class="td" v-if="user.access === 'admin'">{{order.order.city}}</td>
                            <td class="td" v-if="user.access === 'admin'">{{order.restaurant}}</td>
                            <td class="td">
                                <select :class="order.status === 4 ? 'status_select green' : order.status === 5 ? 'status_select orange' : 'status_select'" v-model="order.status" @change="check(index, order)">
                                    <option v-for="(status, id) in statuses" :value="id" :key="id">{{status}}</option>
                                </select>
                            </td>
                            <td class="td">
                                <button class="search_btn"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lk/search_icon.svg"  @click="currentOrderId = index" alt=""></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div id="load">Идет загрузка, подождите немного</div>
                </div>
            </div>
        </section>

    </main>

</template>

<script>
import $ from 'jquery'
import 'datatables'
import 'datatables/media/css/jquery.dataTables.css'
import axios from '@/router/http'
import Navigate from '@/pages/lk/user/navigate'
export default {
  name: 'monitor',
  components: {Navigate},
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      orders: [],
      ordersCopy: [],
      currentOrderId: null,
      currentOrder: {},
      statuses: [],
      cancelOrder: null,
      cancelIndex: null,
      textCancel: null
    }
  },
  methods: {
    saveCancel () {
      if (!this.textCancel || this.textCancel === '' || this.textCancel === ' ' || this.textCancel === null) alert('Вам необходимо указать причину отмены')
      else {
        var formData = new FormData()
        formData.append('id', this.id)
        formData.append('uid', this.$root.auth.uid)
        formData.append('order_id', this.cancelOrder)
        formData.append('text', this.textCancel)
        formData.append('status', this.orders[this.cancelIndex].status)
        axios.post('https://lk.when-hungry.com/mobile/save-status',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((response) => {
          if (response.data.status === 'error') {
            alert(response.data.text)
          } else {
            this.ordersCopy[this.cancelIndex].status = parseInt(this.orders[this.cancelIndex].status)
            this.cancelIndex = null
            this.cancelOrder = null
            this.textCancel = null
            setTimeout(() => {
              alert('Статус изменен')
            }, 1)
          }
        })
      }
    },
    check (index, order) {
      this.cancelIndex = index
      if (order.status === '5' || order.status === '6') {
        this.textCancel = null
        this.cancelOrder = order.id
      } else {
        if (confirm('Вы действительно хотите поменять статус?')) {
          var formData = new FormData()
          formData.append('id', this.id)
          formData.append('uid', this.$root.auth.uid)
          formData.append('order_id', order.id)
          formData.append('status', this.orders[this.cancelIndex].status)
          axios.post('https://lk.when-hungry.com/mobile/save-status',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
            if (response.data.status === 'error') {
              alert(response.data.text)
            } else {
              this.ordersCopy[this.cancelIndex].status = parseInt(this.orders[this.cancelIndex].status)
              setTimeout(() => {
                alert('Статус изменен')
              }, 1)
            }
          })
        } else {
          this.orders[this.cancelIndex].status = parseInt(this.ordersCopy[this.cancelIndex].status)
          alert('Вы нажали отмена')
        }
      }
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-online-monitor?uid=' + this.auth.uid).then(response => {
        this.orders = response.data.orders
        this.ordersCopy = JSON.parse(JSON.stringify(this.orders))
        this.statuses = response.data.statuses
      })
    }
  },
  watch: {
    'cancelOrder' (val, oldVal) {
      if (!val && this.cancelIndex !== null) {
        alert('Вы отменили изменение статуса')
        this.orders[this.cancelIndex].status = parseInt(this.ordersCopy[this.cancelIndex].status)
      }
    },
    'currentOrderId' (val) {
      if (val === null) this.currentOrder = {}
      else this.currentOrder = this.orders[val].order
    },
    orders () {
      setTimeout(() => {
        $('.monitor').on('init.dt', function () {
          $('#load').hide()
        }).DataTable({
          'order': [[ 0, 'desc' ]],
          'language': {
            'decimal': '',
            'emptyTable': 'No data available in table',
            'info': 'С _START_ до _END_ из _TOTAL_ записей',
            'infoEmpty': 'С 0 до 0 из 0 записей',
            'infoFiltered': '(filtered from _MAX_ total entries)',
            'infoPostFix': '',
            'thousands': ',',
            'lengthMenu': 'Выводить по _MENU_',
            'loadingRecords': 'Loading...',
            'processing': 'Processing...',
            'search': 'Искать:',
            'zeroRecords': 'No matching records found',
            'paginate': {
              'first': 'First',
              'last': 'Last',
              'next': 'След',
              'previous': 'Пред'
            },
            'aria': {
              'sortAscending': ': activate to sort column ascending',
              'sortDescending': ': activate to sort column descending'
            }
          }
        })
      }, 300)
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  }
}
</script>

<style>
table.dataTable.no-footer {
    display: block;
}
.monitor {
display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/monitor.vue